import { createElement, lazy } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import { ModalContainer } from "@/3514/components"
import { EModalId } from "@/3514/store/modal"

const LazyCancelSessionContainer: LazyExoticComponent<FC> = lazy((): Promise<{ default: FC }> => import("./cancel")),
    LazyCancelledSessionContainer: LazyExoticComponent<FC> = lazy(
        (): Promise<{ default: FC }> => import("./cancelled")
    ),
    LazyScheduleAvailableContainer: LazyExoticComponent<FC> = lazy(
        (): Promise<{ default: FC }> => import("./schedule-available")
    ),
    LazyGiftSessionContainer: LazyExoticComponent<FC> = lazy((): Promise<{ default: FC }> => import("./gift")),
    LazyGiftedSessionContainer: LazyExoticComponent<FC> = lazy((): Promise<{ default: FC }> => import("./gifted")),
    LazySessionReschedulesContainer: LazyExoticComponent<FC> = lazy(
        (): Promise<{ default: FC }> => import("./reschedules")
    ),
    LazyLateEditContainer: LazyExoticComponent<FC> = lazy((): Promise<{ default: FC }> => import("./late-edit"))

const CancelSessionModal: FC = (): ReactElement =>
        createElement(ModalContainer, { modalId: EModalId.CancelSession, container: LazyCancelSessionContainer }),
    CancelledSessionModal: FC = (): ReactElement =>
        createElement(ModalContainer, { modalId: EModalId.CancelledSession, container: LazyCancelledSessionContainer }),
    ScheduleAvailableModal: FC = (): ReactElement =>
        createElement(ModalContainer, {
            modalId: EModalId.ScheduleAvailableSessions,
            container: LazyScheduleAvailableContainer
        }),
    GiftSessionModal: FC = (): ReactElement =>
        createElement(ModalContainer, {
            modalId: EModalId.Coach_GiftSession,
            container: LazyGiftSessionContainer
        }),
    GiftedSessionModal: FC = (): ReactElement =>
        createElement(ModalContainer, {
            modalId: EModalId.Coach_GiftedSession,
            container: LazyGiftedSessionContainer
        }),
    SessionReschedulesModal: FC = (): ReactElement =>
        createElement(ModalContainer, {
            modalId: EModalId.SessionReschedules,
            container: LazySessionReschedulesContainer
        }),
    LateEditSessionModal: FC = (): ReactElement =>
        createElement(ModalContainer, {
            modalId: EModalId.LateEditSession,
            container: LazyLateEditContainer
        })

export default {
    CancelSessionModal,
    CancelledSessionModal,
    ScheduleAvailableModal,
    GiftSessionModal,
    GiftedSessionModal,
    SessionReschedulesModal,
    LateEditSessionModal
}
